export default __webpack_public_path__ + "static/media/curved-arrow-up-right.98885c99.svg";